import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  List,
  ListItem,
  ListItemText,
  Link as MuiLink,
} from '@material-ui/core';
import { DefectDojoProduct, Engagement } from '../utils/types';

interface ProductInfoCardProps {
  product: DefectDojoProduct;
  engagements: Engagement[];
  baseUrl: string;
}

export const ProductInfoCard = ({
  product,
  engagements,
  baseUrl,
}: ProductInfoCardProps) => {
  const activeEngagements = engagements.filter(
    e => e.status !== 'Completed',
  );

  return (
    <Card>
      <CardHeader title="Informações do Projeto" />
      <CardContent>
        <Typography variant="subtitle2" color="textSecondary">
          Nome
        </Typography>
        <Typography variant="body1" gutterBottom>
          {product.name}
        </Typography>

        <Typography variant="subtitle2" color="textSecondary">
          Descrição
        </Typography>
        <Typography variant="body1" gutterBottom>
          {product.description || 'Sem descrição'}
        </Typography>

        {product.prod_type_name && (
          <>
            <Typography variant="subtitle2" color="textSecondary">
              Tipo
            </Typography>
            <Typography variant="body1" gutterBottom>
              {product.prod_type_name}
            </Typography>
          </>
        )}

        <Typography variant="subtitle2" color="textSecondary">
          Data de Criação
        </Typography>
        <Typography variant="body1" gutterBottom>
          {product.created}
        </Typography>

        <Typography
          variant="subtitle2"
          color="textSecondary"
          style={{ marginTop: 16 }}
        >
          Engagements Ativos ({activeEngagements.length})
        </Typography>
        {activeEngagements.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            Nenhum engagement ativo
          </Typography>
        ) : (
          <List dense>
            {activeEngagements.map(e => (
              <ListItem key={e.id} disableGutters>
                <ListItemText
                  primary={
                    <MuiLink
                      href={`${baseUrl}/engagement/${e.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {e.name}
                    </MuiLink>
                  }
                  secondary={`${e.engagement_type} — ${e.status}`}
                />
              </ListItem>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
};
